import React, { useEffect } from 'react';
import { useNavigationStore } from '@/store/panelStore';
import { NavigationPanel } from './NavigationPanel';

interface PanelLayoutProps {
  children: React.ReactNode;
}

export const PanelLayout: React.FC<PanelLayoutProps> = ({ children }) => {
  const { isMobile, isCollapsed, setMobile } = useNavigationStore();

  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setMobile(mobile);
    };

    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setMobile]);

  return (
    <div className="min-h-[100svh] bg-gray-50 dark:bg-gray-900 flex justify-center">
      {/* Centered container for the entire app */}
      <div className="w-full md:w-1/2 min-h-[100svh] relative">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main Content Area */}
        <div
          className="transition-all duration-300 ease-in-out min-h-[100svh]"
          style={{
            marginLeft: !isMobile ? (isCollapsed ? '4rem' : '16rem') : '0',
          }}
        >
          {/* Page Content */}
          <div className={`${!isMobile ? 'h-[100svh] overflow-y-auto' : ''}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};